module.exports = __webpack_public_path__ + "static/media/icons.3fcad21f.svg";